import { ORGANIZATION_TYPES, REGEX_EXPS } from "utils/constants";
import { createContractNumberValidation } from "utils/helpers/validations";
import * as yup from "yup";

const validator = (errors) => {
  const requiredString = yup
    .string()
    .typeError(errors.REQUIRED)
    .required(errors.REQUIRED);

  const requiredName = yup
    .string()
    .typeError(errors.REQUIRED)
    .matches(REGEX_EXPS.name, errors.INVALID_NAME)
    .required(errors.REQUIRED);

  return yup.object().shape({
    name: requiredString,
    type: requiredString,
    siretNumber: yup.mixed().when("type", {
      is: ORGANIZATION_TYPES.OTHER,
      then: yup
        .string()
        .typeError(errors.REQUIRED)
        .matches(/^\d{14}$/, errors.EXACT_LENGTH.replace("{length}", "14"))
        .required(errors.REQUIRED),
    }),

    user: yup.object().when("type", {
      is: ORGANIZATION_TYPES.OTHER,
      then: yup.object().shape({
        firstname: requiredName,
        lastname: requiredName,
        email: yup
          .string()
          .typeError(errors.REQUIRED)
          .email(errors.EMAIL)
          .required(errors.REQUIRED),
        phone: yup
          .string()
          .nullable()
          .test("isValid", errors.INVALID_VALUE, function (value) {
            if (!value) return true;
            return new RegExp(REGEX_EXPS.phone).test(value);
          }),
      }),
    }),

    contract: yup.object().shape({
      issuanceDate: requiredString,
      identifier: createContractNumberValidation(errors, REGEX_EXPS, {
        required: false,
      }),
      subjects: yup.object().shape({
        commercialReferent: yup.string().nullable(),
        internalNotes: yup.string().nullable(),
      }),
    }),
  });
};

export default validator;
